import {
  ScrollView,
  TouchableOpacity,
  TextInput,
  Modal,
  Image,
  Text,
  View,
} from "react-native";
import React from "react";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import {
  StackActions,
  useNavigation,
  useRoute,
} from "@react-navigation/native";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import { AppColors } from "../../../../utility/AppColors";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppImages } from "../../../../utility/AppImages";
import { CommonButton } from "../../../../common/CommonButton";
import { AppScreens } from "../../../Utility/AppScreens";
import StreamerViewComponent from "../../../../Components/notification-common-components/StreamerViewComponent";
import SvgImage from "../../../../Components/choose-avatar-components/SvgImage";

export default function SuccessFullSignUpModal({
  title = "signing-up successful",
  description = "You have successfully signed-up for",
  closeSuccessSignUpModal,
  openSuccessSignUpModal,
  closeSignUpModal,
  item,
  screenName = "",
}) {
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const attendeeCount = item.attendeeCount ? item.attendeeCount : 0;
  const ticketNumber = attendeeCount + 1;
  return (
    <Modal transparent={openSuccessSignUpModal} visible={true} animationType="slide">
      <View style={styles.container}>
        <View style={styles.mainView}>
          <View
            style={{ flexDirection: "row", justifyContent: "space-between" }}
          >
            <Text style={[AppFontStyle.BOLD_ANYBODY_32, { flex: 1 }]}>
              {title}
            </Text>
            <TouchableOpacity
              onPress={() => {
                closeSuccessSignUpModal();
                closeSignUpModal(true);
              }}
              style={{
                backgroundColor: AppColors.gray_212222,
                width: 30,
                height: 30,
                borderRadius: 7,
                borderColor: AppColors.grayColor_393939,
                borderWidth: 1,
              }}
            >
              <Image
                source={AppImages.icCancel}
                style={{ height: 13, width: 15, margin: 5 }}
                resizeMode="contain"
              />
            </TouchableOpacity>
          </View>
          <View
            style={{
              height: 2,
              backgroundColor: AppColors.gray_1E1E1E,
              marginTop: 22,
            }}
          />
          <Text style={[AppFontStyle.REGULAR_ANYBODY_14, { marginTop: 30 }]}>
            {description}{" "}
            <Text style={{ color: "#EF4444" }}>
              {item.eventTitle || item.title}
            </Text>
          </Text>

          <Text style={[AppFontStyle.REGULAR_ANYBODY_20, { marginTop: 35 }]}>
            Your Seat
          </Text>

          <View
            style={{
              backgroundColor: "rgba(31, 41, 55, 0.50)",
              height: 166,
              borderRadius: 8,
              borderWidth: 0.8,
              borderColor: "#374151",
              marginVertical: 10,
              flexDirection: "row",
              justifyContent: "space-evenly",
              gap: 50,
            }}
          >
            <View
              style={{
                borderRadius: 100,
                marginVertical: 23,
                alignSelf: "center",
              }}
            >
              <Image
                source={AppImages.icTicket}
                style={{ height: 50, width: 100, borderRadius: 10 }}
              />{" "}
            </View>
            <View>
              <Text
                style={[AppFontStyle.REGULAR_ANYBODY_15, { marginTop: 58 }]}
              >
                Seat number
              </Text>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_28,
                  { marginTop: 10, textAlign: "center" },
                ]}
              >
                {ticketNumber}
              </Text>
            </View>
          </View>
          <View style={styles.buttonContainer}>
            <CommonButton
              title="Back to Dashboard"
              onTap={() => {
                closeSuccessSignUpModal();
                closeSignUpModal(true);
                navigation.dispatch(
                  StackActions.replace(AppScreens.DrawerRoute, {
                    screen: "HomeTabStack",
                  })
                );
              }}
              buttonStyle={styles.btnDashboard}
              textStyle={[styles.buttonText, { color: AppColors.white }]}
            />
            <CommonButton
              title="OK, View event"
              onTap={() => {
                if (screenName === "liveScreen") {
                  navigateToScreen(navigation, AppScreens.LiveStreaming, {
                    eventId: item.eventID,
                  });
                } else if (item.status === "live") {
                  navigateToScreen(navigation, AppScreens.LiveStreaming, {
                    eventId: item.eventID,
                  });
                } else if (item.status === "Upcoming") {
                  navigateToScreen(navigation, AppScreens.GameShowScreen, {
                    eventID: item.eventID,
                  });
                } else if (item.status === "completed") {
                  navigateToScreen(navigation, AppScreens.PastEvent, {
                    eventID: item.eventID,
                  });
                }
                closeSuccessSignUpModal();
                closeSignUpModal(true);
              }}
              buttonStyle={styles.btnWatchEvent}
              textStyle={[styles.buttonText, { color: AppColors.white }]}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
      justifyContent: "center",
      alignItems: "center",
    },
    mainView: {
      backgroundColor: "#111827",
      borderRadius: 8,
      borderWidth: 1.6,
      borderColor: "rgba(239, 68, 68, 0.50)",
      padding: 20,
      width: "40%",
      paddingHorizontal: 25,
      marginHorizontal: 40,
      marginVertical: 50,
      alignSelf: "center",
    },
    buttonContainer: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 15,
      marginTop: 30,
    },
    buttonText: {
      fontSize: 14,
      fontWeight: "700",
    },
    btnWatchEvent: {
      flex: 1,
      paddingVertical: 8,
      paddingHorizontal: 24,
      backgroundColor: "#DC2626",
      shadowOpacity: 0,
      height: 40,
      borderRadius: 8,
      justifyContent: "center",
      alignItems: "center",
    },
    btnDashboard: {
      flex: 1,
      paddingVertical: 8,
      paddingHorizontal: 24,
      backgroundColor: "transparent",
      borderWidth: 1,
      borderColor: AppColors.gray_C3C3C3,
      shadowOpacity: 0,
      height: 40,
      borderRadius: 8,
      justifyContent: "center",
      alignItems: "center",
    },
  },
  {
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "flex-end",
      },
      mainView: {
        backgroundColor: "#111827",
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderWidth: 1.6,
        borderBottomWidth: 0,
        borderColor: "rgba(239, 68, 68, 0.50)",
        padding: 15,
        width: "100%",
        paddingHorizontal: 20,
        marginHorizontal: 0,
        marginVertical: 0,
      },
      buttonContainer: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 8,
        marginTop: 30,
        paddingBottom: 20,
      },
      buttonText: {
        fontSize: 11,
        fontWeight: "700",
      },
      btnWatchEvent: {
        flex: 1,
        paddingVertical: 6,
        paddingHorizontal: 8,
        backgroundColor: "#DC2626",
        shadowOpacity: 0,
        height: 36,
        borderRadius: 8,
        justifyContent: "center",
        alignItems: "center",
      },
      btnDashboard: {
        flex: 1,
        paddingVertical: 6,
        paddingHorizontal: 8,
        backgroundColor: "transparent",
        borderWidth: 1,
        borderColor: AppColors.gray_C3C3C3,
        shadowOpacity: 0,
        height: 36,
        borderRadius: 8,
        justifyContent: "center",
        alignItems: "center",
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "flex-end",
      },
      mainView: {
        backgroundColor: "#111827",
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderWidth: 1.6,
        borderBottomWidth: 0,
        borderColor: "rgba(239, 68, 68, 0.50)",
        padding: 20,
        width: "100%",
        paddingHorizontal: 25,
        marginHorizontal: 0,
        marginVertical: 0,
      },
      buttonContainer: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 12,
        marginTop: 30,
        paddingBottom: 20,
      },
      buttonText: {
        fontSize: 12,
        fontWeight: "700",
      },
      btnWatchEvent: {
        flex: 1,
        paddingVertical: 7,
        paddingHorizontal: 16,
        backgroundColor: "#DC2626",
        shadowOpacity: 0,
        height: 38,
        borderRadius: 8,
        justifyContent: "center",
        alignItems: "center",
      },
      btnDashboard: {
        flex: 1,
        paddingVertical: 7,
        paddingHorizontal: 16,
        backgroundColor: "transparent",
        borderWidth: 1,
        borderColor: AppColors.gray_C3C3C3,
        shadowOpacity: 0,
        height: 38,
        borderRadius: 8,
        justifyContent: "center",
        alignItems: "center",
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        backgroundColor: "#111827",
        borderRadius: 8,
        borderWidth: 1.6,
        borderColor: "rgba(239, 68, 68, 0.50)",
        padding: 20,
        width: "60%",
        paddingHorizontal: 25,
        marginHorizontal: 40,
        marginVertical: 50,
        alignSelf: "center",
      },
      buttonContainer: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 15,
        marginTop: 30,
      },
      btnWatchEvent: {
        flex: 1,
        paddingVertical: 7,
        paddingHorizontal: 22,
        backgroundColor: "#DC2626",
        shadowOpacity: 0,
        height: 38,
        borderRadius: 8,
        justifyContent: "center",
        alignItems: "center",
      },
      btnDashboard: {
        flex: 1,
        paddingVertical: 7,
        paddingHorizontal: 22,
        backgroundColor: "transparent",
        borderWidth: 1,
        borderColor: AppColors.gray_C3C3C3,
        shadowOpacity: 0,
        height: 38,
        borderRadius: 8,
        justifyContent: "center",
        alignItems: "center",
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        backgroundColor: "#111827",
        borderRadius: 8,
        borderWidth: 1.6,
        borderColor: "rgba(239, 68, 68, 0.50)",
        padding: 20,
        width: "50%",
        paddingHorizontal: 25,
        marginHorizontal: 40,
        marginVertical: 50,
        alignSelf: "center",
      },
      buttonContainer: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 15,
        marginTop: 30,
      },
      btnWatchEvent: {
        flex: 1,
        paddingVertical: 8,
        paddingHorizontal: 24,
        backgroundColor: "#DC2626",
        shadowOpacity: 0,
        height: 40,
        borderRadius: 8,
        justifyContent: "center",
        alignItems: "center",
      },
      btnDashboard: {
        flex: 1,
        paddingVertical: 8,
        paddingHorizontal: 24,
        backgroundColor: "transparent",
        borderWidth: 1,
        borderColor: AppColors.gray_C3C3C3,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 8,
        justifyContent: "center",
        alignItems: "center",
      },
    },
  }
);
